import { VscGame } from 'react-icons/vsc';
import { EmptyState } from '@/components/custom/empty-state';
import { t } from 'i18next';
import {
  ChallengeActivities,
  ChallengeActivitiesBody,
  ChallengeActivitiesCard,
  ChallengeActivitiesCardContent,
  ChallengeActivitiesCardIcon,
  ChallengeActivitiesCardName,
  ChallengeActivitiesCardTitle,
  ChallengeActivitiesCardValue,
  ChallengeActivitiesHeader,
  ChallengeActivitiesTitle
} from '@/components/custom/challenge';

export default function WeekChallengeActivities({ conquers }) {
  return (
    <ChallengeActivities>
      <ChallengeActivitiesHeader>
        <ChallengeActivitiesTitle>Conquistas da semana</ChallengeActivitiesTitle>
      </ChallengeActivitiesHeader>

      <ChallengeActivitiesBody>
        {conquers && conquers.length === 0 ? (
          <EmptyState
            type="data"
            text={t('emptyState.achievementsText')}
            variant="plain"
          />
        ) : (
          conquers?.map((item, i) => {
            return (
              <ChallengeActivitiesCard key={i}>
                <ChallengeActivitiesCardIcon>
                  <VscGame />
                </ChallengeActivitiesCardIcon>

                <ChallengeActivitiesCardContent>
                  <ChallengeActivitiesCardTitle title={item?.title}>{item?.title}</ChallengeActivitiesCardTitle>
                  <ChallengeActivitiesCardName title={item?.user?.name}>{item?.user?.name}</ChallengeActivitiesCardName>
                </ChallengeActivitiesCardContent>

                <ChallengeActivitiesCardValue>{item?.done ? `${item?.['challenge-attempt-items']?.[0].score ?? 0}pts` : ''}</ChallengeActivitiesCardValue>
              </ChallengeActivitiesCard>
            );
          })
        )}
      </ChallengeActivitiesBody>
    </ChallengeActivities>
  );
}
